const colors = {
  primaryWhite: '#ffffff',
  primaryIndigo: '#050038',
  primaryBlue: '#4262FF',
  primaryBlueHover: '#455BED',
  primaryBlueActive: '#3D51D4',

  outspoken: '#FFD02F',
  passionate: '#3F53D9',
  bold: '#FF6575',
  grey: '#F2F2F2',
  greyish: 'rgba(5, 0, 56, 0.6)', //! TODO: change to proper naming
  secondaryGrey: 'rgba(255, 255, 255, 0.75)', //! TODO: change to proper naming
  human: '#FFBFBF',

  lightBlue: 'rgba(63, 83, 217, 0.1)',
  lightPink: 'rgba(255, 191, 191, 0.4)',
  lightYellow: 'rgba(255, 208, 47, 0.3)',
  lightGray: 'rgba(5, 0, 56, 0.1)',

  // TODO: Onboarding theme
  dimmedGray: '#9B99AF',
  dimmestGray: '#E1E0E7',

  workshopGray: 'rgba(5, 0, 56, 0.03)',
  solutionsGray: '#C0BFCD',

  primary40: '#D9E0FF',
  primary80: '#6881FF',

  placeholderColor: '#5f5c80',
}

export default colors
